export default __webpack_public_path__ + "static/media/collaborating.c8f8c403.svg";